var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "goods-manage" },
    [
      _c(
        "div",
        { staticClass: "filter-container" },
        [
          _c("el-input", {
            staticClass: "filter-item",
            staticStyle: { width: "200px" },
            attrs: { placeholder: "菜品id/名称", clearable: "" },
            nativeOn: {
              keyup: function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                ) {
                  return null
                }
                return _vm.handleFilter($event)
              },
            },
            model: {
              value: _vm.listQuery.keywords,
              callback: function ($$v) {
                _vm.$set(_vm.listQuery, "keywords", $$v)
              },
              expression: "listQuery.keywords",
            },
          }),
          _vm._v(" "),
          _c("el-cascader", {
            staticClass: "filter-item",
            staticStyle: { width: "200px" },
            attrs: {
              options: _vm.categories,
              props: {
                value: "id",
                label: "label",
                leaf: "leaf",
                checkStrictly: true,
              },
              placeholder: "菜品分类",
              clearable: "",
            },
            model: {
              value: _vm.listQuery.categories,
              callback: function ($$v) {
                _vm.$set(_vm.listQuery, "categories", $$v)
              },
              expression: "listQuery.categories",
            },
          }),
          _vm._v(" "),
          _c(
            "el-select",
            {
              staticStyle: { width: "200px" },
              attrs: { placeholder: "菜品类型", clearable: "" },
              model: {
                value: _vm.listQuery.goodsType,
                callback: function ($$v) {
                  _vm.$set(_vm.listQuery, "goodsType", $$v)
                },
                expression: "listQuery.goodsType",
              },
            },
            [
              _c("el-option", {
                key: "单品",
                attrs: { label: "单品", value: "1" },
              }),
              _vm._v(" "),
              _c("el-option", {
                key: "套餐",
                attrs: { label: "套餐", value: "2" },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-select",
            {
              staticStyle: { width: "200px" },
              attrs: { placeholder: "菜品状态", clearable: "" },
              model: {
                value: _vm.listQuery.status,
                callback: function ($$v) {
                  _vm.$set(_vm.listQuery, "status", $$v)
                },
                expression: "listQuery.status",
              },
            },
            [
              _c("el-option", {
                key: "下架",
                attrs: { label: "下架", value: "0" },
              }),
              _vm._v(" "),
              _c("el-option", {
                key: "上架",
                attrs: { label: "上架", value: "1" },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              directives: [{ name: "waves", rawName: "v-waves" }],
              staticClass: "filter-item",
              attrs: { type: "primary", icon: "el-icon-search" },
              on: { click: _vm.handleFilter },
            },
            [_vm._v("\n      搜索\n    ")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              directives: [{ name: "waves", rawName: "v-waves" }],
              staticClass: "filter-item",
              attrs: { type: "primary", icon: "el-icon-download" },
              on: {
                click: function ($event) {
                  return _vm.handleSyncGoods()
                },
              },
            },
            [_vm._v("\n      全量同步商品\n    ")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              directives: [{ name: "waves", rawName: "v-waves" }],
              staticClass: "filter-item",
              attrs: { type: "primary", icon: "el-icon-upload2" },
              on: {
                click: function ($event) {
                  return _vm.handleUploadUpdate()
                },
              },
            },
            [_vm._v("\n      导入更新\n    ")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              directives: [{ name: "waves", rawName: "v-waves" }],
              staticClass: "filter-item",
              staticStyle: { display: "none" },
              attrs: { type: "info", icon: "el-icon-picture" },
              on: {
                click: function ($event) {
                  return _vm.handleStoreImageImport()
                },
              },
            },
            [_vm._v("\n      导入门店图片(开发用)\n    ")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              directives: [{ name: "waves", rawName: "v-waves" }],
              staticClass: "filter-item",
              attrs: { type: "success", icon: "el-icon-picture-outline" },
              on: {
                click: function ($event) {
                  return _vm.handleNewStoreImageImport()
                },
              },
            },
            [_vm._v("\n      导入门店图片\n    ")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              directives: [{ name: "waves", rawName: "v-waves" }],
              staticClass: "filter-item",
              staticStyle: { display: "none" },
              attrs: { type: "primary", icon: "el-icon-download" },
              on: {
                click: function ($event) {
                  return _vm.handleSyncMakeMethod()
                },
              },
            },
            [_vm._v("\n      同步做法\n    ")]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.listLoading,
              expression: "listLoading",
            },
          ],
          key: _vm.tableKey,
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.dataList,
            stripe: "",
            border: "",
            fit: "",
            "highlight-current-row": "",
          },
        },
        [
          _c("el-table-column", {
            attrs: {
              label: "菜品id",
              prop: "id",
              align: "center",
              width: "100",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "菜品名称",
              prop: "goodsName",
              align: "center",
              "min-width": "120",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "菜品编码",
              prop: "goodsCode",
              align: "center",
              width: "120",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "菜品类型",
              prop: "goodsType",
              align: "center",
              width: "120",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    row.goodsType == 1
                      ? _c("span", [_vm._v("单品")])
                      : _vm._e(),
                    _vm._v(" "),
                    row.goodsType == 2
                      ? _c("span", [_vm._v("套餐")])
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "所属大类",
              prop: "categoryFirstName",
              align: "center",
              width: "120",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "所属小类",
              prop: "categorySecondName",
              align: "center",
              width: "120",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "菜品价格", align: "center", width: "120" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _vm._v(
                      "\n        ￥" + _vm._s(row.marketPrice) + "\n      "
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "商品图", align: "center", width: "120" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    row.goodsThumbnailUrl === null ||
                    row.goodsThumbnailUrl === "" ||
                    row.goodsThumbnailUrl === undefined
                      ? _c("span", [_vm._v("\n          未上传图片\n        ")])
                      : _c("el-image", {
                          staticStyle: { width: "80px", height: "40px" },
                          attrs: {
                            src: _vm.resPath + row.goodsThumbnailUrl,
                            fit: "contain",
                            "preview-src-list": [
                              _vm.resPath + row.goodsThumbnailUrl,
                            ],
                            "preview-teleported": "",
                          },
                        }),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("tableFrom.CreationTime"),
              width: "100px",
              align: "center",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    row.createTime
                      ? _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm._f("parseTime")(
                                row.createTime,
                                "{y}-{m}-{d} {h}:{i}:{s}"
                              )
                            )
                          ),
                        ])
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("tableFrom.UpdateTime"),
              width: "100px",
              align: "center",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    row.updateTime
                      ? _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm._f("parseTime")(
                                row.updateTime,
                                "{y}-{m}-{d} {h}:{i}:{s}"
                              )
                            )
                          ),
                        ])
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "餐盒费/个", align: "center", width: "120" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _vm._v("\n        ￥" + _vm._s(row.boxPrice) + "\n      "),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "上架",
              prop: "categorySecondName",
              align: "center",
              width: "120",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c("el-switch", {
                      attrs: {
                        "active-color": "#13ce66",
                        "inactive-color": "#ff4949",
                        "active-value": 1,
                        "inactive-value": 0,
                      },
                      on: {
                        change: function ($event) {
                          return _vm.handleStatus(row.id, $event)
                        },
                      },
                      model: {
                        value: row.status,
                        callback: function ($$v) {
                          _vm.$set(row, "status", $$v)
                        },
                        expression: "row.status",
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "价格同步",
              prop: "priceSyncFlag",
              align: "center",
              width: "120",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c("el-switch", {
                      attrs: {
                        "active-color": "#13ce66",
                        "inactive-color": "#ff4949",
                        "active-value": 1,
                        "inactive-value": 0,
                      },
                      on: {
                        change: function ($event) {
                          return _vm.handlePriceSyncFlag(row.id, $event)
                        },
                      },
                      model: {
                        value: row.priceSyncFlag,
                        callback: function ($$v) {
                          _vm.$set(row, "priceSyncFlag", $$v)
                        },
                        expression: "row.priceSyncFlag",
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              fixed: "right",
              label: _vm.$t("tableFrom.Operation"),
              align: "center",
              "min-width": "250",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c(
                      "div",
                      { staticClass: "operation-buttons" },
                      [
                        _c(
                          "el-button",
                          {
                            attrs: {
                              size: "mini",
                              type: "primary",
                              icon: "el-icon-edit",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.openEditInTab(row)
                              },
                            },
                          },
                          [_vm._v("\n            编辑\n          ")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            attrs: {
                              size: "mini",
                              type: "warning",
                              icon: "el-icon-knife-fork",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.handleOpenGoodsMakeMethod(row.id)
                              },
                            },
                          },
                          [_vm._v("\n            做法\n          ")]
                        ),
                        _vm._v(" "),
                        row.goodsType == 2
                          ? _c(
                              "el-button",
                              {
                                attrs: {
                                  size: "mini",
                                  type: "success",
                                  icon: "el-icon-s-data",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.openDetailDialog(row.id)
                                  },
                                },
                              },
                              [_vm._v("\n            明细\n          ")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            attrs: {
                              icon: "el-icon-download",
                              size: "mini",
                              type: "primary",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.handleSyncGoods(row.id)
                              },
                            },
                          },
                          [_vm._v("\n            同步\n          ")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            attrs: {
                              size: "mini",
                              type: "warning",
                              icon: "el-icon-shopping-bag-1",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.handleOpenEstimateInfo(row.id)
                              },
                            },
                          },
                          [_vm._v("\n            估清/限量\n          ")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            attrs: {
                              size: "mini",
                              type: "success",
                              icon: "el-icon-refresh",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.handleFlashGoodMenu(row.id)
                              },
                            },
                          },
                          [_vm._v("\n            刷新缓存\n          ")]
                        ),
                      ],
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "pagination-container" },
        [
          _c("el-pagination", {
            attrs: {
              background: "",
              layout: "total, sizes, prev, pager, next, jumper",
              "current-page": _vm.listQuery.page,
              "page-size": _vm.listQuery.limit,
              "page-sizes": [10, 20, 50, 100],
              total: _vm.total,
            },
            on: {
              "current-change": _vm.handleCurrentChange,
              "size-change": _vm.handleSizeChange,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: { visible: _vm.previewDialog.visible, width: "400px" },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.previewDialog, "visible", $event)
            },
          },
        },
        [
          _c("img", {
            staticStyle: { width: "100%" },
            attrs: { src: _vm.previewDialog.url, alt: "预览图" },
          }),
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "做法管理",
            visible: _vm.makeMethodVisible,
            width: "700px",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.makeMethodVisible = $event
            },
          },
        },
        [
          _c(
            "el-select",
            {
              staticStyle: { width: "200px" },
              attrs: {
                placeholder: "请选择单位",
                clearable: "",
                filterable: "",
              },
              model: {
                value: _vm.makeMethodFilter.unitId,
                callback: function ($$v) {
                  _vm.$set(_vm.makeMethodFilter, "unitId", $$v)
                },
                expression: "makeMethodFilter.unitId",
              },
            },
            _vm._l(_vm.unitList, function (item) {
              return _c("el-option", {
                key: item.id,
                attrs: { label: item.unitName, value: item.id },
              })
            }),
            1
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              directives: [{ name: "waves", rawName: "v-waves" }],
              staticClass: "filter-item",
              attrs: { type: "primary", icon: "el-icon-search" },
              on: {
                click: function ($event) {
                  return _vm.getMakeMethodInfo()
                },
              },
            },
            [_vm._v("\n      搜索\n    ")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              directives: [{ name: "waves", rawName: "v-waves" }],
              staticClass: "filter-item",
              staticStyle: { "margin-bottom": "10px" },
              attrs: { type: "primary" },
              on: {
                click: function ($event) {
                  _vm.makeMethodAddVisible = true
                },
              },
            },
            [_vm._v("\n      添加做法\n    ")]
          ),
          _vm._v(" "),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.makeMethodData,
                "row-key": _vm.getRowKey,
                border: "",
                "tree-props": {
                  children: "children",
                  hasChildren: "hasChildren",
                },
              },
            },
            [
              _c("el-table-column", { attrs: { label: "单位", prop: "data" } }),
              _vm._v(" "),
              _c("el-table-column", { attrs: { label: "类型", prop: "name" } }),
              _vm._v(" "),
              _c("el-table-column", { attrs: { label: "排序", prop: "sort" } }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("tableFrom.Operation"),
                  align: "center",
                  width: "100",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c(
                          "div",
                          [
                            !row.children
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: { size: "mini", type: "warning" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.deleteMakeMethod(row.id)
                                      },
                                    },
                                  },
                                  [_vm._v("\n              删除\n            ")]
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "添加做法",
            visible: _vm.makeMethodAddVisible,
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.makeMethodAddVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            { staticClass: "dialog-form" },
            [
              _c(
                "el-form-item",
                { attrs: { label: "单位" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "400px" },
                      attrs: { placeholder: "请选择单位", filterable: "" },
                      model: {
                        value: _vm.addMakeMethodForm.unitId,
                        callback: function ($$v) {
                          _vm.$set(_vm.addMakeMethodForm, "unitId", $$v)
                        },
                        expression: "addMakeMethodForm.unitId",
                      },
                    },
                    _vm._l(_vm.unitList, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.unitName, value: item.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "做法" } },
                [
                  _c("el-cascader", {
                    staticStyle: { width: "400px" },
                    attrs: {
                      "show-all-levels": false,
                      placeholder: "请选择做法",
                      options: _vm.makeMethods,
                      props: {
                        value: "id",
                        leaf: "leaf",
                        multiple: true,
                        emitPath: false,
                      },
                    },
                    model: {
                      value: _vm.addMakeMethodForm.makeMethodIds,
                      callback: function ($$v) {
                        _vm.$set(_vm.addMakeMethodForm, "makeMethodIds", $$v)
                      },
                      expression: "addMakeMethodForm.makeMethodIds",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "drawer-footer" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.makeMethodAddVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.addMakeMethod },
                },
                [_vm._v("保存")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "套餐明细",
            visible: _vm.detailVisible,
            width: "1000px",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.detailVisible = $event
            },
          },
        },
        _vm._l(_vm.detailData, function (detail) {
          return _c(
            "span",
            { staticClass: "group-block" },
            [
              _c("div", { staticClass: "group-header" }, [
                _c("div", { staticClass: "group-title" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(detail.groupName) +
                      "|" +
                      _vm._s(detail.groupCode) +
                      "\n        "
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "group-time" }, [
                  _vm._v(
                    "\n          数量:" +
                      _vm._s(detail.minNum) +
                      " - " +
                      _vm._s(detail.maxNum) +
                      "\n        "
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.listLoading,
                      expression: "listLoading",
                    },
                  ],
                  key: detail.id,
                  staticStyle: { width: "100%" },
                  attrs: {
                    data: detail.details,
                    stripe: "",
                    border: "",
                    fit: "",
                    "highlight-current-row": "",
                  },
                  on: {
                    "sort-change": function ($event) {
                      return _vm.handleTableSortChange($event, detail)
                    },
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      label: "商品id",
                      prop: "goodsId",
                      align: "center",
                      width: "100",
                      sortable: "custom",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      label: "商品名称",
                      prop: "goodsName",
                      align: "center",
                      "min-width": "120",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      label: "商品编码",
                      prop: "goodsCode",
                      align: "center",
                      width: "120",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      label: "单位名称",
                      prop: "unitName",
                      align: "center",
                      width: "120",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "数量", align: "center", width: "120" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (ref) {
                            var row = ref.row
                            return [
                              _vm._v(
                                "\n            " +
                                  _vm._s(row.limitCount) +
                                  " - " +
                                  _vm._s(row.maxCount) +
                                  "\n          "
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      true
                    ),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "是否必选", align: "center", width: "120" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (ref) {
                            var row = ref.row
                            return [
                              row.requireFlag == 1
                                ? _c("i", { staticClass: "el-icon-check" })
                                : _c("i", { staticClass: "el-icon-close" }),
                            ]
                          },
                        },
                      ],
                      null,
                      true
                    ),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      label: "菜品价格",
                      align: "center",
                      width: "120",
                      prop: "price",
                      sortable: "custom",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (ref) {
                            var row = ref.row
                            return [
                              _vm._v(
                                "\n            ￥" +
                                  _vm._s(row.price) +
                                  "\n          "
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      true
                    ),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      label: "菜品加价",
                      align: "center",
                      width: "120",
                      prop: "price",
                      sortable: "custom",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (ref) {
                            var row = ref.row
                            return [
                              _vm._v(
                                "\n            ￥" +
                                  _vm._s(row.addPrice) +
                                  "\n          "
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      true
                    ),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "商品图", align: "center", width: "120" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (ref) {
                            var row = ref.row
                            return [
                              row.goodsThumbnailUrl === null ||
                              row.goodsThumbnailUrl === "" ||
                              row.goodsThumbnailUrl === undefined
                                ? _c("span", [
                                    _vm._v(
                                      "\n              未上传图片\n            "
                                    ),
                                  ])
                                : _c("el-image", {
                                    staticStyle: {
                                      width: "80px",
                                      height: "40px",
                                    },
                                    attrs: {
                                      src: _vm.resPath + row.goodsThumbnailUrl,
                                      fit: "contain",
                                      "preview-src-list": [
                                        _vm.resPath + row.goodsThumbnailUrl,
                                      ],
                                      "preview-teleported": "",
                                    },
                                  }),
                            ]
                          },
                        },
                      ],
                      null,
                      true
                    ),
                  }),
                ],
                1
              ),
            ],
            1
          )
        }),
        0
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "添加菜品",
            visible: _vm.detailAddVisible,
            width: "1000px",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.detailAddVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "filter-container",
              staticStyle: { "margin-bottom": "10px" },
            },
            [
              _c("el-input", {
                staticClass: "filter-item",
                staticStyle: { width: "200px" },
                attrs: { placeholder: "菜品id/名称", clearable: "" },
                nativeOn: {
                  keyup: function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.handleDetailAddFilter($event)
                  },
                },
                model: {
                  value: _vm.detailAddQuery.keywords,
                  callback: function ($$v) {
                    _vm.$set(_vm.detailAddQuery, "keywords", $$v)
                  },
                  expression: "detailAddQuery.keywords",
                },
              }),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.handleDetailAddFilter },
                },
                [_vm._v("搜索")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.detailAddVisible = false
                    },
                  },
                },
                [_vm._v("返回")]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              key: "333",
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.detailAddData,
                stripe: "",
                border: "",
                fit: "",
                "highlight-current-row": "",
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  label: "商品名称",
                  prop: "goodsName",
                  align: "center",
                  "min-width": "120",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "商品编码",
                  prop: "goodsCode",
                  align: "center",
                  width: "120",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "所属大类",
                  prop: "categoryFirstName",
                  align: "center",
                  width: "120",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "所属小类",
                  prop: "categorySecondName",
                  align: "center",
                  width: "120",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "商品图", align: "center", width: "120" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        row.goodsThumbnailUrl === null ||
                        row.goodsThumbnailUrl === "" ||
                        row.goodsThumbnailUrl === undefined
                          ? _c("span", [
                              _vm._v("\n            未上传图片\n          "),
                            ])
                          : _c("el-image", {
                              staticStyle: { width: "80px", height: "40px" },
                              attrs: {
                                src: _vm.resPath + row.goodsThumbnailUrl,
                                fit: "contain",
                                "preview-src-list": [
                                  _vm.resPath + row.goodsThumbnailUrl,
                                ],
                                "preview-teleported": "",
                              },
                            }),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  fixed: "right",
                  label: _vm.$t("tableFrom.Operation"),
                  align: "center",
                  width: "250",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c(
                          "div",
                          [
                            _c(
                              "el-button",
                              {
                                attrs: {
                                  disabled: row.groupId != null,
                                  size: "mini",
                                  type: "success",
                                  icon: "el-icon-collection",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.addGoods(row.id)
                                  },
                                },
                              },
                              [_vm._v("\n              添加\n            ")]
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _vm.detailAddTotal > 0
            ? _c("sw-page", {
                key: "4",
                staticStyle: { display: "block", float: "none" },
                attrs: {
                  listQuery: _vm.detailAddQuery,
                  total: _vm.detailAddTotal,
                  pos: "btmRight",
                },
                on: { retPage: _vm.retPage },
              })
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c("storeMenuDialog", {
        attrs: {
          visible: _vm.storeMenuVisible,
          "selected-store-ids": _vm.storeMenuForm.relatedStoreIdList,
          "region-store-list": _vm.regionStoreList,
          loading: _vm.listLoading,
        },
        on: {
          "update:visible": function ($event) {
            _vm.storeMenuVisible = $event
          },
          submit: _vm.handleFullSyncGoods,
          close: function ($event) {
            _vm.storeMenuVisible = false
          },
        },
      }),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "导入更新",
            visible: _vm.batchOperateVisible,
            width: "38%",
            "destroy-on-close": true,
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.batchOperateVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "batchOperateForm",
              attrs: {
                "label-position": "right",
                model: _vm.batchOperateData,
                "label-width": "90px",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "导入类型", prop: "type" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "360px" },
                      attrs: { placeholder: "请选择导入类型", clearable: "" },
                      model: {
                        value: _vm.batchOperateData.type,
                        callback: function ($$v) {
                          _vm.$set(_vm.batchOperateData, "type", $$v)
                        },
                        expression: "batchOperateData.type",
                      },
                    },
                    [
                      _c("el-option", {
                        attrs: { value: "simple", label: "单品" },
                      }),
                      _vm._v(" "),
                      _c("el-option", {
                        attrs: { value: "package", label: "套餐" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "导入数据" } },
                [
                  _c(
                    "el-upload",
                    {
                      ref: "uploadBatchOperate",
                      attrs: {
                        limit: 1,
                        accept: ".xlsx",
                        headers: _vm.headers,
                        action: _vm.batchOperateUploadUrl,
                        "on-success": _vm.handleFileSuccess,
                        "auto-upload": false,
                        data: _vm.batchOperateData,
                        drag: "",
                      },
                    },
                    [
                      _c("i", { staticClass: "el-icon-upload" }),
                      _vm._v(" "),
                      _c("div", { staticClass: "el-upload__text" }, [
                        _vm._v("\n            上传\n          "),
                      ]),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "导入模板" } },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.handleDownloadTemplate },
                    },
                    [_vm._v("\n          下载导入模板\n        ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.batchOperateVisible = false
                    },
                  },
                },
                [_vm._v("\n          返回\n        ")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.submitBatchOperateUpload },
                },
                [_vm._v("\n          确认\n        ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "导入门店图片",
            visible: _vm.storeImageImportVisible,
            width: "38%",
            "destroy-on-close": true,
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.storeImageImportVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            { attrs: { "label-position": "right", "label-width": "90px" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "导入数据" } },
                [
                  _c(
                    "el-upload",
                    {
                      ref: "uploadStoreImage",
                      attrs: {
                        limit: 1,
                        accept: ".xlsx, .xls",
                        headers: _vm.headers,
                        action: _vm.storeImageUploadUrl,
                        "on-success": _vm.handleStoreImageSuccess,
                        "auto-upload": false,
                        drag: "",
                      },
                    },
                    [
                      _c("i", { staticClass: "el-icon-upload" }),
                      _vm._v(" "),
                      _c("div", { staticClass: "el-upload__text" }, [
                        _vm._v("\n            上传Excel文件\n          "),
                      ]),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "导入模板" } },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.handleDownloadStoreImageTemplate },
                    },
                    [_vm._v("\n          下载导入模板\n        ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.storeImageImportVisible = false
                    },
                  },
                },
                [_vm._v("\n        返回\n      ")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.submitStoreImageUpload },
                },
                [_vm._v("\n        确认\n      ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "导入门店图片",
            visible: _vm.newStoreImageImportVisible,
            width: "58%",
            "destroy-on-close": true,
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.newStoreImageImportVisible = $event
            },
          },
        },
        [
          _c("div", { staticClass: "new-import-container" }, [
            _c("div", { staticClass: "step-card" }, [
              _c("div", { staticClass: "step-header" }, [
                _c("span", { staticClass: "step-badge" }, [_vm._v("步骤 1")]),
                _vm._v(" "),
                _c("span", { staticClass: "step-title" }, [
                  _vm._v("上传图片素材到图片库"),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "step-desc" }, [
                _vm._v(
                  "\n          请先上传商品图片（支持多选）或包含多张图片的 .zip 压缩包。若图片名称与库中已有图片重复，将自动以新图片覆盖旧图片。\n        "
                ),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "step-content" },
                [
                  _c(
                    "el-upload",
                    {
                      ref: "uploadImagePool",
                      attrs: {
                        headers: _vm.headers,
                        action: _vm.imagePoolUploadUrl,
                        "auto-upload": false,
                        multiple: true,
                        "on-success": _vm.handleImagePoolSuccess,
                        "on-error": _vm.handleImagePoolError,
                        accept: ".jpg,.jpeg,.png,.gif,.bmp,.webp,.zip",
                        drag: "",
                      },
                    },
                    [
                      _c("i", { staticClass: "el-icon-upload" }),
                      _vm._v(" "),
                      _c("div", { staticClass: "el-upload__text" }, [
                        _vm._v(
                          "\n              将图片或 .zip 压缩包拖到此处，或 "
                        ),
                        _c("em", [_vm._v("点击选取")]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "el-upload__tip",
                          attrs: { slot: "tip" },
                          slot: "tip",
                        },
                        [
                          _vm._v(
                            "\n              支持 .jpg、.png、.webp 等图片格式，或打包后的 .zip 压缩包（无需提前解压）\n            "
                          ),
                        ]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        "margin-top": "10px",
                        display: "flex",
                        "align-items": "center",
                      },
                    },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            type: "primary",
                            size: "small",
                            icon: "el-icon-upload2",
                            loading: _vm.imagePoolUploading,
                          },
                          on: { click: _vm.submitImagePoolUpload },
                        },
                        [_vm._v("\n              开始上传素材\n            ")]
                      ),
                      _vm._v(" "),
                      _vm.imagePoolUploadMsg
                        ? _c(
                            "span",
                            {
                              staticStyle: {
                                "margin-left": "15px",
                                "font-size": "13px",
                                color: "#67C23A",
                              },
                            },
                            [
                              _c("i", { staticClass: "el-icon-circle-check" }),
                              _vm._v(
                                " " +
                                  _vm._s(_vm.imagePoolUploadMsg) +
                                  "\n            "
                              ),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "step-card",
                staticStyle: { "margin-top": "20px" },
              },
              [
                _c("div", { staticClass: "step-header" }, [
                  _c("span", { staticClass: "step-badge" }, [_vm._v("步骤 2")]),
                  _vm._v(" "),
                  _c("span", { staticClass: "step-title" }, [
                    _vm._v("导入 Excel 匹配并更新门店图片"),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "step-desc" }, [
                  _vm._v(
                    "\n          Excel 包含【门店ID/门店名称】、【商品编码】、【商品缩略图名称】、【商品封面图名称】。系统会按图片名称自动在已上传素材中匹配并更新对应门店商品的图片。\n        "
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "step-content" },
                  [
                    _c(
                      "div",
                      { staticStyle: { "margin-bottom": "12px" } },
                      [
                        _c(
                          "el-button",
                          {
                            attrs: {
                              type: "primary",
                              plain: "",
                              size: "small",
                              icon: "el-icon-download",
                            },
                            on: {
                              click: _vm.handleDownloadNewStoreImageTemplate,
                            },
                          },
                          [
                            _vm._v(
                              "\n              下载导入模板.xlsx\n            "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-upload",
                      {
                        ref: "uploadExcelFile",
                        attrs: {
                          headers: _vm.headers,
                          action: _vm.newStoreImageExcelUploadUrl,
                          "auto-upload": false,
                          limit: 1,
                          "on-success": _vm.handleNewStoreImageExcelSuccess,
                          "on-error": _vm.handleNewStoreImageExcelError,
                          accept: ".xlsx,.xls",
                          drag: "",
                        },
                      },
                      [
                        _c("i", { staticClass: "el-icon-document" }),
                        _vm._v(" "),
                        _c("div", { staticClass: "el-upload__text" }, [
                          _vm._v(
                            "\n              将填写好的 Excel 文件拖到此处，或 "
                          ),
                          _c("em", [_vm._v("点击选取")]),
                        ]),
                      ]
                    ),
                  ],
                  1
                ),
              ]
            ),
            _vm._v(" "),
            _vm.importResultData
              ? _c(
                  "div",
                  {
                    staticClass: "result-card",
                    staticStyle: { "margin-top": "20px" },
                  },
                  [
                    _c("div", { staticClass: "result-header" }, [
                      _c("i", {
                        staticClass: "el-icon-info",
                        staticStyle: {
                          color: "#409EFF",
                          "margin-right": "6px",
                        },
                      }),
                      _vm._v(" "),
                      _c("span", [_vm._v("导入执行结果")]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "result-summary" },
                      [
                        _c("el-tag", { attrs: { type: "info" } }, [
                          _vm._v(
                            "总行数: " +
                              _vm._s(_vm.importResultData.totalCount || 0)
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "el-tag",
                          {
                            staticStyle: { "margin-left": "8px" },
                            attrs: { type: "success" },
                          },
                          [
                            _vm._v(
                              "成功更新: " +
                                _vm._s(_vm.importResultData.successCount || 0)
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _vm.importResultData.skipCount > 0
                          ? _c(
                              "el-tag",
                              {
                                staticStyle: { "margin-left": "8px" },
                                attrs: { type: "warning" },
                              },
                              [
                                _vm._v(
                                  "跳过/未匹配: " +
                                    _vm._s(_vm.importResultData.skipCount)
                                ),
                              ]
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.importResultData.details &&
                    _vm.importResultData.details.length > 0
                      ? _c("div", { staticClass: "result-details" }, [
                          _c("div", { staticClass: "details-title" }, [
                            _vm._v("处理明细提示："),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "details-list" },
                            _vm._l(
                              _vm.importResultData.details,
                              function (tip, idx) {
                                return _c(
                                  "div",
                                  { key: idx, staticClass: "detail-item" },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(tip) +
                                        "\n            "
                                    ),
                                  ]
                                )
                              }
                            ),
                            0
                          ),
                        ])
                      : _vm._e(),
                  ]
                )
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.newStoreImageImportVisible = false
                    },
                  },
                },
                [_vm._v("\n        关闭\n      ")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.excelImporting },
                  on: { click: _vm.submitNewStoreImageExcelUpload },
                },
                [_vm._v("\n        确认导入并更新\n      ")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }